import { createFileRoute } from '@tanstack/react-router';
import { CreditMemoDetailPanel } from '@/components/organisms/credit-memos/CreditMemoDetailPanel';

export const Route = createFileRoute('/_dashboard/dashboard/credit-memos/$id')({
  component: CreditMemoDetailRoute,
});

function CreditMemoDetailRoute() {
  const { id } = Route.useParams();
  return <CreditMemoDetailPanel id={id} />;
}
